import { FormField, FormRenderTypes } from "../Shared/Components/FormRenderer";
import { FormRenderGroupTypes } from "../Shared/Components/FormRenderer/FormRenderGroup.types";

export const countryFields: FormField[] = [
	{
		name: "name",
		label: "Nazwa kraju",
		type: FormRenderTypes.input,
		value: "",
		placeholder: "Wprowadź nazwę kraju",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "description",
		label: "Opis",
		type: FormRenderTypes.wysiwyg,
		value: "",
		placeholder: "Opis kraju",
		group: FormRenderGroupTypes.basic,
	},
	{
		name: "published",
		label: "Opublikuj kraj",
		type: FormRenderTypes.switch,
		group: FormRenderGroupTypes.configuration,
	},
];
